{
    "login.logging_in": "Du wirst angemeldet... \nFalls du nach spätestens einer Minute nicht weitergeleitet wirst, schließe dieses Fenster und versuche dich erneut einzuloggen. Falls das Problem weiterhin auftritt, wende dich bitte an: UserLab@mdr.de"
}
